// extracted by mini-css-extract-plugin
export var overlay = "fadeInOnFontLoad-module--overlay--94724";